import _regeneratorRuntime from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { Absorber } from "./Options/Classes/Absorber";
import { Absorbers } from "./Absorbers";
import { isInArray } from "../../Utils";

var AbsorbersPlugin = /*#__PURE__*/function () {
  function AbsorbersPlugin() {
    _classCallCheck(this, AbsorbersPlugin);

    this.id = "absorbers";
  }

  _createClass(AbsorbersPlugin, [{
    key: "getPlugin",
    value: function getPlugin(container) {
      return new Absorbers(container);
    }
  }, {
    key: "needsPlugin",
    value: function needsPlugin(options) {
      var _a, _b, _c;

      if (options === undefined) {
        return false;
      }

      var absorbers = options.absorbers;
      var loadAbsorbers = false;

      if (absorbers instanceof Array) {
        if (absorbers.length) {
          loadAbsorbers = true;
        }
      } else if (absorbers !== undefined) {
        loadAbsorbers = true;
      } else if (((_c = (_b = (_a = options.interactivity) === null || _a === void 0 ? void 0 : _a.events) === null || _b === void 0 ? void 0 : _b.onClick) === null || _c === void 0 ? void 0 : _c.mode) && isInArray("absorber", options.interactivity.events.onClick.mode)) {
        loadAbsorbers = true;
      }

      return loadAbsorbers;
    }
  }, {
    key: "loadOptions",
    value: function loadOptions(options, source) {
      var _a, _b;

      if (!this.needsPlugin(options) && !this.needsPlugin(source)) {
        return;
      }

      var optionsCast = options;

      if (source === null || source === void 0 ? void 0 : source.absorbers) {
        if ((source === null || source === void 0 ? void 0 : source.absorbers) instanceof Array) {
          optionsCast.absorbers = source === null || source === void 0 ? void 0 : source.absorbers.map(function (s) {
            var tmp = new Absorber();
            tmp.load(s);
            return tmp;
          });
        } else {
          var absorberOptions = optionsCast.absorbers;

          if ((absorberOptions === null || absorberOptions === void 0 ? void 0 : absorberOptions.load) === undefined) {
            optionsCast.absorbers = absorberOptions = new Absorber();
          }

          absorberOptions.load(source === null || source === void 0 ? void 0 : source.absorbers);
        }
      }

      var interactivityAbsorbers = (_b = (_a = source === null || source === void 0 ? void 0 : source.interactivity) === null || _a === void 0 ? void 0 : _a.modes) === null || _b === void 0 ? void 0 : _b.absorbers;

      if (interactivityAbsorbers) {
        if (interactivityAbsorbers instanceof Array) {
          optionsCast.interactivity.modes.absorbers = interactivityAbsorbers.map(function (s) {
            var tmp = new Absorber();
            tmp.load(s);
            return tmp;
          });
        } else {
          var _absorberOptions = optionsCast.interactivity.modes.absorbers;

          if ((_absorberOptions === null || _absorberOptions === void 0 ? void 0 : _absorberOptions.load) === undefined) {
            optionsCast.interactivity.modes.absorbers = _absorberOptions = new Absorber();
          }

          _absorberOptions.load(interactivityAbsorbers);
        }
      }
    }
  }]);

  return AbsorbersPlugin;
}();

export function loadAbsorbersPlugin(_x) {
  return _loadAbsorbersPlugin.apply(this, arguments);
}

function _loadAbsorbersPlugin() {
  _loadAbsorbersPlugin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(engine) {
    var plugin;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            plugin = new AbsorbersPlugin();
            _context.next = 3;
            return engine.addPlugin(plugin);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadAbsorbersPlugin.apply(this, arguments);
}